import { render, staticRenderFns } from "./Document-count-graph.vue?vue&type=template&id=cd903e12&scoped=true"
import script from "./Document-count-graph.vue?vue&type=script&lang=js"
export * from "./Document-count-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd903e12",
  null
  
)

export default component.exports